import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

function FilterBar({ fields, values, onChange, onReset, children }) {
  return (
    <Card sx={{ boxShadow: "none", border: "1px solid", borderColor: "grey.200" }}>
      <MDBox p={2}>
        <Grid container spacing={2} alignItems="center">
          {fields.map((field) => (
            <Grid item xs={12} sm={6} md={3} lg="auto" key={field.name}>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  minWidth: 180,
                  "& .MuiOutlinedInput-root": { height: "34px" },
                }}
              >
                <InputLabel id={`${field.name}-select-label`}>{field.label}</InputLabel>
                <Select
                  labelId={`${field.name}-select-label`}
                  label={field.label}
                  value={values?.[field.name] ?? ""}
                  onChange={(e) => onChange(field.name, e.target.value)}
                  sx={{ "& .MuiSelect-select": { paddingTop: "6px", paddingBottom: "6px" } }}
                >
                  <MenuItem value="">All</MenuItem>
                  {field.options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          ))}

          {children}

          <Grid item xs={12} sm="auto" sx={{ ml: { sm: "auto" } }}>
            <MDButton variant="text" color="secondary" size="small" onClick={onReset}>
              Reset
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

FilterBar.defaultProps = {
  values: {},
  children: null,
};

FilterBar.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          label: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default FilterBar;
